var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.general)?_c('van-button',_vm._g(_vm._b({class:{'can-hover': _vm.isPC, 'button-general': true}},'van-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('van-button',_vm._g(_vm._b({class:{'can-hover': _vm.isPC}},'van-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }